import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/mobile`;

const lang = localStorage.getItem("language") || "en";

export const socialLogin = async (userData) => {
  try {
    const payload = {
      name: userData.name || "",
      email: userData.email || "",
      country_code: userData.country_code || "",
      phone: userData.phone || "",
      provider: userData.provider,
      provider_id: userData.provider_id,
      device_name: typeof navigator !== "undefined" ? navigator.userAgent : "",
      device_id: userData.device_id || "web",
      os_platform: "web",
      os_version: typeof navigator !== "undefined" ? navigator.userAgent : "",
      app_version: "1.0.0",
      timezone:
        typeof Intl !== "undefined"
          ? Intl.DateTimeFormat().resolvedOptions().timeZone
          : "",
      fcm_token: userData.fcm_token || "",
    };

    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Accept-Language": lang || "ar",
        "x-api-key": "base64:NnQp8jV6bp5tErWgwYoKjSY0YODOO4maVCrkqWCFgT8=",
      },
      withCredentials: true,
    };

    const response = await axios.post(
      `${API_URL}/social-login`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error.message;
    }
  }
};
